/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AiUsageRouteImport } from './routes/ai-usage'
import { Route as CleverscoreRouteImport } from './routes/cleverscore'
import { Route as ContactUsRouteImport } from './routes/contact-us'
import { Route as CookiePreferencesRouteImport } from './routes/cookie-preferences'
import { Route as LegalNoticesRouteImport } from './routes/legal-notices'
import { Route as MyCooptationsRouteImport } from './routes/my-cooptations'
import { Route as MyNetworkRouteImport } from './routes/my-network'
import { Route as PasswordResetRouteImport } from './routes/password-reset'
import { Route as PersonalDataRouteImport } from './routes/personal-data'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as RecommendRouteImport } from './routes/recommend'
import { Route as TermsOfUseRouteImport } from './routes/terms-of-use'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as BackofficeIndexRouteImport } from './routes/backoffice/index'
import { Route as BackofficeInvitationsRouteImport } from './routes/backoffice/invitations'
import { Route as ConsultantsIndexRouteImport } from './routes/consultants/index'
import { Route as ConsultantsConsultantIdRouteImport } from './routes/consultants/$consultantId'
import { Route as InscriptionTokenRouteImport } from './routes/inscription/$token'
import { Route as InscriptionExpireRouteImport } from './routes/inscription/expire'
import { Route as InscriptionMerciRouteImport } from './routes/inscription/merci'
import { Route as OptOutTokenRouteImport } from './routes/opt-out/$token'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AiUsageRoute = AiUsageRouteImport.update({
  id: '/ai-usage',
  path: '/ai-usage',
  getParentRoute: () => rootRouteImport,
} as any)
const CleverscoreRoute = CleverscoreRouteImport.update({
  id: '/cleverscore',
  path: '/cleverscore',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactUsRoute = ContactUsRouteImport.update({
  id: '/contact-us',
  path: '/contact-us',
  getParentRoute: () => rootRouteImport,
} as any)
const CookiePreferencesRoute = CookiePreferencesRouteImport.update({
  id: '/cookie-preferences',
  path: '/cookie-preferences',
  getParentRoute: () => rootRouteImport,
} as any)
const LegalNoticesRoute = LegalNoticesRouteImport.update({
  id: '/legal-notices',
  path: '/legal-notices',
  getParentRoute: () => rootRouteImport,
} as any)
const MyCooptationsRoute = MyCooptationsRouteImport.update({
  id: '/my-cooptations',
  path: '/my-cooptations',
  getParentRoute: () => rootRouteImport,
} as any)
const MyNetworkRoute = MyNetworkRouteImport.update({
  id: '/my-network',
  path: '/my-network',
  getParentRoute: () => rootRouteImport,
} as any)
const PasswordResetRoute = PasswordResetRouteImport.update({
  id: '/password-reset',
  path: '/password-reset',
  getParentRoute: () => rootRouteImport,
} as any)
const PersonalDataRoute = PersonalDataRouteImport.update({
  id: '/personal-data',
  path: '/personal-data',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const RecommendRoute = RecommendRouteImport.update({
  id: '/recommend',
  path: '/recommend',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsOfUseRoute = TermsOfUseRouteImport.update({
  id: '/terms-of-use',
  path: '/terms-of-use',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => rootRouteImport,
} as any)
const BackofficeIndexRoute = BackofficeIndexRouteImport.update({
  id: '/backoffice/',
  path: '/backoffice/',
  getParentRoute: () => rootRouteImport,
} as any)
const BackofficeInvitationsRoute = BackofficeInvitationsRouteImport.update({
  id: '/backoffice/invitations',
  path: '/backoffice/invitations',
  getParentRoute: () => rootRouteImport,
} as any)
const ConsultantsIndexRoute = ConsultantsIndexRouteImport.update({
  id: '/consultants/',
  path: '/consultants/',
  getParentRoute: () => rootRouteImport,
} as any)
const ConsultantsConsultantIdRoute = ConsultantsConsultantIdRouteImport.update({
  id: '/consultants/$consultantId',
  path: '/consultants/$consultantId',
  getParentRoute: () => rootRouteImport,
} as any)
const InscriptionTokenRoute = InscriptionTokenRouteImport.update({
  id: '/inscription/$token',
  path: '/inscription/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const InscriptionExpireRoute = InscriptionExpireRouteImport.update({
  id: '/inscription/expire',
  path: '/inscription/expire',
  getParentRoute: () => rootRouteImport,
} as any)
const InscriptionMerciRoute = InscriptionMerciRouteImport.update({
  id: '/inscription/merci',
  path: '/inscription/merci',
  getParentRoute: () => rootRouteImport,
} as any)
const OptOutTokenRoute = OptOutTokenRouteImport.update({
  id: '/opt-out/$token',
  path: '/opt-out/$token',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/ai-usage': typeof AiUsageRoute
  '/cleverscore': typeof CleverscoreRoute
  '/contact-us': typeof ContactUsRoute
  '/cookie-preferences': typeof CookiePreferencesRoute
  '/legal-notices': typeof LegalNoticesRoute
  '/my-cooptations': typeof MyCooptationsRoute
  '/my-network': typeof MyNetworkRoute
  '/password-reset': typeof PasswordResetRoute
  '/personal-data': typeof PersonalDataRoute
  '/profile': typeof ProfileRoute
  '/recommend': typeof RecommendRoute
  '/terms-of-use': typeof TermsOfUseRoute
  '/backoffice/invitations': typeof BackofficeInvitationsRoute
  '/consultants/$consultantId': typeof ConsultantsConsultantIdRoute
  '/inscription/$token': typeof InscriptionTokenRoute
  '/inscription/expire': typeof InscriptionExpireRoute
  '/inscription/merci': typeof InscriptionMerciRoute
  '/opt-out/$token': typeof OptOutTokenRoute
  '/admin/': typeof AdminIndexRoute
  '/backoffice/': typeof BackofficeIndexRoute
  '/consultants/': typeof ConsultantsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/ai-usage': typeof AiUsageRoute
  '/cleverscore': typeof CleverscoreRoute
  '/contact-us': typeof ContactUsRoute
  '/cookie-preferences': typeof CookiePreferencesRoute
  '/legal-notices': typeof LegalNoticesRoute
  '/my-cooptations': typeof MyCooptationsRoute
  '/my-network': typeof MyNetworkRoute
  '/password-reset': typeof PasswordResetRoute
  '/personal-data': typeof PersonalDataRoute
  '/profile': typeof ProfileRoute
  '/recommend': typeof RecommendRoute
  '/terms-of-use': typeof TermsOfUseRoute
  '/backoffice/invitations': typeof BackofficeInvitationsRoute
  '/consultants/$consultantId': typeof ConsultantsConsultantIdRoute
  '/inscription/$token': typeof InscriptionTokenRoute
  '/inscription/expire': typeof InscriptionExpireRoute
  '/inscription/merci': typeof InscriptionMerciRoute
  '/opt-out/$token': typeof OptOutTokenRoute
  '/admin': typeof AdminIndexRoute
  '/backoffice': typeof BackofficeIndexRoute
  '/consultants': typeof ConsultantsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/ai-usage': typeof AiUsageRoute
  '/cleverscore': typeof CleverscoreRoute
  '/contact-us': typeof ContactUsRoute
  '/cookie-preferences': typeof CookiePreferencesRoute
  '/legal-notices': typeof LegalNoticesRoute
  '/my-cooptations': typeof MyCooptationsRoute
  '/my-network': typeof MyNetworkRoute
  '/password-reset': typeof PasswordResetRoute
  '/personal-data': typeof PersonalDataRoute
  '/profile': typeof ProfileRoute
  '/recommend': typeof RecommendRoute
  '/terms-of-use': typeof TermsOfUseRoute
  '/backoffice/invitations': typeof BackofficeInvitationsRoute
  '/consultants/$consultantId': typeof ConsultantsConsultantIdRoute
  '/inscription/$token': typeof InscriptionTokenRoute
  '/inscription/expire': typeof InscriptionExpireRoute
  '/inscription/merci': typeof InscriptionMerciRoute
  '/opt-out/$token': typeof OptOutTokenRoute
  '/admin/': typeof AdminIndexRoute
  '/backoffice/': typeof BackofficeIndexRoute
  '/consultants/': typeof ConsultantsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/ai-usage'
    | '/cleverscore'
    | '/contact-us'
    | '/cookie-preferences'
    | '/legal-notices'
    | '/my-cooptations'
    | '/my-network'
    | '/password-reset'
    | '/personal-data'
    | '/profile'
    | '/recommend'
    | '/terms-of-use'
    | '/backoffice/invitations'
    | '/consultants/$consultantId'
    | '/inscription/$token'
    | '/inscription/expire'
    | '/inscription/merci'
    | '/opt-out/$token'
    | '/admin/'
    | '/backoffice/'
    | '/consultants/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/ai-usage'
    | '/cleverscore'
    | '/contact-us'
    | '/cookie-preferences'
    | '/legal-notices'
    | '/my-cooptations'
    | '/my-network'
    | '/password-reset'
    | '/personal-data'
    | '/profile'
    | '/recommend'
    | '/terms-of-use'
    | '/backoffice/invitations'
    | '/consultants/$consultantId'
    | '/inscription/$token'
    | '/inscription/expire'
    | '/inscription/merci'
    | '/opt-out/$token'
    | '/admin'
    | '/backoffice'
    | '/consultants'
  id:
    | '__root__'
    | '/'
    | '/ai-usage'
    | '/cleverscore'
    | '/contact-us'
    | '/cookie-preferences'
    | '/legal-notices'
    | '/my-cooptations'
    | '/my-network'
    | '/password-reset'
    | '/personal-data'
    | '/profile'
    | '/recommend'
    | '/terms-of-use'
    | '/backoffice/invitations'
    | '/consultants/$consultantId'
    | '/inscription/$token'
    | '/inscription/expire'
    | '/inscription/merci'
    | '/opt-out/$token'
    | '/admin/'
    | '/backoffice/'
    | '/consultants/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AiUsageRoute: typeof AiUsageRoute
  CleverscoreRoute: typeof CleverscoreRoute
  ContactUsRoute: typeof ContactUsRoute
  CookiePreferencesRoute: typeof CookiePreferencesRoute
  LegalNoticesRoute: typeof LegalNoticesRoute
  MyCooptationsRoute: typeof MyCooptationsRoute
  MyNetworkRoute: typeof MyNetworkRoute
  PasswordResetRoute: typeof PasswordResetRoute
  PersonalDataRoute: typeof PersonalDataRoute
  ProfileRoute: typeof ProfileRoute
  RecommendRoute: typeof RecommendRoute
  TermsOfUseRoute: typeof TermsOfUseRoute
  BackofficeInvitationsRoute: typeof BackofficeInvitationsRoute
  ConsultantsConsultantIdRoute: typeof ConsultantsConsultantIdRoute
  InscriptionTokenRoute: typeof InscriptionTokenRoute
  InscriptionExpireRoute: typeof InscriptionExpireRoute
  InscriptionMerciRoute: typeof InscriptionMerciRoute
  OptOutTokenRoute: typeof OptOutTokenRoute
  AdminIndexRoute: typeof AdminIndexRoute
  BackofficeIndexRoute: typeof BackofficeIndexRoute
  ConsultantsIndexRoute: typeof ConsultantsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ai-usage': {
      id: '/ai-usage'
      path: '/ai-usage'
      fullPath: '/ai-usage'
      preLoaderRoute: typeof AiUsageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cleverscore': {
      id: '/cleverscore'
      path: '/cleverscore'
      fullPath: '/cleverscore'
      preLoaderRoute: typeof CleverscoreRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact-us': {
      id: '/contact-us'
      path: '/contact-us'
      fullPath: '/contact-us'
      preLoaderRoute: typeof ContactUsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cookie-preferences': {
      id: '/cookie-preferences'
      path: '/cookie-preferences'
      fullPath: '/cookie-preferences'
      preLoaderRoute: typeof CookiePreferencesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legal-notices': {
      id: '/legal-notices'
      path: '/legal-notices'
      fullPath: '/legal-notices'
      preLoaderRoute: typeof LegalNoticesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/my-cooptations': {
      id: '/my-cooptations'
      path: '/my-cooptations'
      fullPath: '/my-cooptations'
      preLoaderRoute: typeof MyCooptationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/my-network': {
      id: '/my-network'
      path: '/my-network'
      fullPath: '/my-network'
      preLoaderRoute: typeof MyNetworkRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/password-reset': {
      id: '/password-reset'
      path: '/password-reset'
      fullPath: '/password-reset'
      preLoaderRoute: typeof PasswordResetRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/personal-data': {
      id: '/personal-data'
      path: '/personal-data'
      fullPath: '/personal-data'
      preLoaderRoute: typeof PersonalDataRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recommend': {
      id: '/recommend'
      path: '/recommend'
      fullPath: '/recommend'
      preLoaderRoute: typeof RecommendRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms-of-use': {
      id: '/terms-of-use'
      path: '/terms-of-use'
      fullPath: '/terms-of-use'
      preLoaderRoute: typeof TermsOfUseRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/admin'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/backoffice/': {
      id: '/backoffice/'
      path: '/backoffice'
      fullPath: '/backoffice/'
      preLoaderRoute: typeof BackofficeIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/backoffice/invitations': {
      id: '/backoffice/invitations'
      path: '/backoffice/invitations'
      fullPath: '/backoffice/invitations'
      preLoaderRoute: typeof BackofficeInvitationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/consultants/': {
      id: '/consultants/'
      path: '/consultants'
      fullPath: '/consultants/'
      preLoaderRoute: typeof ConsultantsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/consultants/$consultantId': {
      id: '/consultants/$consultantId'
      path: '/consultants/$consultantId'
      fullPath: '/consultants/$consultantId'
      preLoaderRoute: typeof ConsultantsConsultantIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inscription/$token': {
      id: '/inscription/$token'
      path: '/inscription/$token'
      fullPath: '/inscription/$token'
      preLoaderRoute: typeof InscriptionTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inscription/expire': {
      id: '/inscription/expire'
      path: '/inscription/expire'
      fullPath: '/inscription/expire'
      preLoaderRoute: typeof InscriptionExpireRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inscription/merci': {
      id: '/inscription/merci'
      path: '/inscription/merci'
      fullPath: '/inscription/merci'
      preLoaderRoute: typeof InscriptionMerciRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/opt-out/$token': {
      id: '/opt-out/$token'
      path: '/opt-out/$token'
      fullPath: '/opt-out/$token'
      preLoaderRoute: typeof OptOutTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AiUsageRoute: AiUsageRoute,
  CleverscoreRoute: CleverscoreRoute,
  ContactUsRoute: ContactUsRoute,
  CookiePreferencesRoute: CookiePreferencesRoute,
  LegalNoticesRoute: LegalNoticesRoute,
  MyCooptationsRoute: MyCooptationsRoute,
  MyNetworkRoute: MyNetworkRoute,
  PasswordResetRoute: PasswordResetRoute,
  PersonalDataRoute: PersonalDataRoute,
  ProfileRoute: ProfileRoute,
  RecommendRoute: RecommendRoute,
  TermsOfUseRoute: TermsOfUseRoute,
  BackofficeInvitationsRoute: BackofficeInvitationsRoute,
  ConsultantsConsultantIdRoute: ConsultantsConsultantIdRoute,
  InscriptionTokenRoute: InscriptionTokenRoute,
  InscriptionExpireRoute: InscriptionExpireRoute,
  InscriptionMerciRoute: InscriptionMerciRoute,
  OptOutTokenRoute: OptOutTokenRoute,
  AdminIndexRoute: AdminIndexRoute,
  BackofficeIndexRoute: BackofficeIndexRoute,
  ConsultantsIndexRoute: ConsultantsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
